import { withCatalogLayout } from "@/elements-react/catalog-layout/withCatalogLayout";
import { useNotFoundCommon } from "@/pages-react/not-found-page/NotFoundCommon.tsx";
import { LayoutStyleTypes } from "@/util-react/layout.tsx";

export const NotFoundMobile: React.FC = () => {
  const { renderContent } = useNotFoundCommon();

  return <>{renderContent()}</>;
};
